<template>
  <div class="w-full flex flex-col gap-2">
    <label
      class="text-[#121212] font-semibold text-[16px] leading-[24px] flex items-center gap-1"
      style="font-family: 'Open Sans'; font-weight: 600"
    >
      {{ label }}
      <span
        v-if="required"
        class="text-[#E25C5C] font-[500] text-[16px] leading-[24px]"
        >*</span
      >
    </label>
    <div
      class="w-full h-[46px] flex items-center gap-2 border border-[#CCCCCC] rounded-[8px] px-3"
      :class="{ 'border-red-500': errorMessage }"
    >
      <!-- Hex Code Input -->
      <input
        type="text"
        :value="modelValue"
        @input="updateColor($event.target.value)"
        class="w-full h-full text-[#414141] text-[14px] leading-[22.4px] outline-none bg-transparent"
        style="font-family: 'Open Sans'; font-weight: 400"
      />

      <!-- Color Picker (Hidden) -->
      <input
        type="color"
        :value="modelValue"
        @input="updateColor($event.target.value)"
        class="w-0 h-0 opacity-0 absolute"
        ref="colorPicker"
      />

      <!-- Color Preview Box -->
      <div
        class="w-5 h-5 rounded-[4px] cursor-pointer border"
        :style="{ backgroundColor: modelValue }"
        @click="triggerColorPicker"
      ></div>
    </div>

    <!-- Error Message -->
    <p v-if="errorMessage" class="text-red-500 text-[14px]">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script setup>
import { ref } from "vue";

defineProps({
  label: String,
  modelValue: String,
  errorMessage: String,
  required: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue"]);
const colorPicker = ref(null);

// Update color from text input or color picker
const updateColor = (newColor) => {
  if (/^#([0-9A-Fa-f]{6})$/.test(newColor)) {
    emit("update:modelValue", newColor);
  }
};

// Open color picker when clicking the preview box
const triggerColorPicker = () => {
  colorPicker.value.click();
};
</script>
